import { html, LitElement } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { classMap } from 'lit/directives/class-map.js';
import { ProgressMulti } from '@local/webcomponents-progress-multi';

import styleComponent from './_style/progress-container.style.js';

class ComponentProgressContainer extends LitElement {
  static properties = {
    text: { type: String },
    size: { type: String },
    live: { type: String },
    extent: { type: String },
    type: { type: String },
    theme: { type: String }
  };

  static styles = styleComponent;

  constructor() {
    super();
    this.size = 'L';
    this.live = null;
    this.text = '';
    this.extent = 'full';
    this.type = 'progress';
  }

  render() {
    const mainClasses = {
      'progress-container': true,
      [`progress-container--type-${this.type}`]: true,
      [`progress-container--extent-${this.extent}`]: true
    };
    const isAlert = this.live === 'alert';
    const liveRole = isAlert ? 'alert' : this.live ? 'status' : undefined;
    return html`
      <div class="${classMap(mainClasses)}">
        ${
          this.type === 'text'
            ? html`<div
                class="progress-container__text"
                role="${ifDefined(liveRole)}"
                aria-live="${ifDefined(
                  this.live ? (isAlert ? 'assertive' : 'polite') : undefined
                )}"
              >
                ${this.text}
              </div>`
            : ProgressMulti({
                size: this.size,
                text: this.text,
                ariaLive: this.live || 'polite',
                theme: this.theme
              })
        }
      </div>
    `;
  }
}

if (!customElements.get('outbook-progress-container')) {
  customElements.define(
    'outbook-progress-container',
    ComponentProgressContainer
  );
}

export function ProgressContainer(props) {
  const { size, ariaLive, text, isPartial, onlyText, theme } = props;

  return html`
    <outbook-progress-container
      text="${ifDefined(text || undefined)}"
      size="${ifDefined(size || undefined)}"
      live="${ifDefined(ariaLive || undefined)}"
      extent="${isPartial ? 'area' : 'full'}"
      type="${onlyText ? 'text' : 'progress'}"
      theme="${ifDefined(theme || undefined)}"
    ></outbook-progress-container>
  `;
}
